import { InjectionToken } from '@angular/core';

export const PARTIAL_DATA = new InjectionToken<{}>('PARTIAL_DATA');
